//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalGenericNew',

  data() {
    return {
      title: '',
      content: '',
      isSuccess: true,
    }
  },

  computed: {
    titleClasses() {
      return [
        'modal-generic__title',
        this.isSuccess
            ? 'modal-generic__title--success'
            : 'modal-generic__title--error',
      ]
    },
  },

  methods: {
    beforeOpen(event) {
      const params = event?.params || {}

      this.title = params.title || ''
      this.content = params.content || ''
      this.isSuccess = params.isSuccess !== false
    },

    close() {
      this.$modal.hide('modal-generic-new')
    },
  },
}
